var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJamTriangleDangerF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6667 7.6881L35.835 26.2898C37.44 28.9614 36.6517 32.4764 34.0734 34.1398C33.2085 34.7012 32.1995 34.9999 31.1684 34.9998H8.83004C5.79504 34.9998 3.33337 32.4498 3.33337 29.3014C3.33337 28.2364 3.62171 27.1948 4.16337 26.2898L15.3334 7.6881C16.9367 5.01643 20.3267 4.1981 22.905 5.86143C23.6184 6.32143 24.2217 6.94643 24.6667 7.6881ZM20 28.3331C20.4421 28.3331 20.866 28.1575 21.1786 27.8449C21.4911 27.5324 21.6667 27.1085 21.6667 26.6664C21.6667 26.2244 21.4911 25.8005 21.1786 25.4879C20.866 25.1754 20.4421 24.9998 20 24.9998C19.558 24.9998 19.1341 25.1754 18.8215 25.4879C18.509 25.8005 18.3334 26.2244 18.3334 26.6664C18.3334 27.1085 18.509 27.5324 18.8215 27.8449C19.1341 28.1575 19.558 28.3331 20 28.3331ZM20 13.3331C19.558 13.3331 19.1341 13.5087 18.8215 13.8213C18.509 14.1338 18.3334 14.5577 18.3334 14.9998V21.6664C18.3334 22.1085 18.509 22.5324 18.8215 22.8449C19.1341 23.1575 19.558 23.3331 20 23.3331C20.4421 23.3331 20.866 23.1575 21.1786 22.8449C21.4911 22.5324 21.6667 22.1085 21.6667 21.6664V14.9998C21.6667 14.5577 21.4911 14.1338 21.1786 13.8213C20.866 13.5087 20.4421 13.3331 20 13.3331Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJamTriangleDangerF);
export default __webpack_public_path__ + "static/media/jam_triangle-danger-f.be61cb2cba6452c39cb721e87d31b19a.svg";
export { ForwardRef as ReactComponent };